import { KitchenSkill } from '../../../types/content.type';
import { LessonPlan, Recipe } from '../../../types/lessonPlan.type';
import { sortLessonPlanRecipes } from '../../../utils/utils';
import SafeHTMLDisplay from '../../common/SafeHTMLDisplay';
interface RecipeSkillsProps {
  recipe?: Recipe;
  lessonPlan?: LessonPlan;
}
const RecipeSkills: React.FC<RecipeSkillsProps> = ({ recipe, lessonPlan }) => {
  const kitchenSkills: KitchenSkill[] = [];
  const seenSkillIds = new Set<number>();
  if (lessonPlan) {
    sortLessonPlanRecipes(lessonPlan.recipes).forEach((lessonRecipe) => {
      lessonRecipe.kitchen_skills?.forEach((skill) => {
        if (!seenSkillIds.has(skill.id)) {
          seenSkillIds.add(skill.id);
          kitchenSkills.push(skill);
        }
      });
    });
  } else if (recipe) {
    recipe.kitchen_skills?.forEach((skill) => {
      if (!seenSkillIds.has(skill.id)) {
        seenSkillIds.add(skill.id);
        kitchenSkills.push(skill);
      }
    });
  }
  const cleanDescription = (desc: string) => desc.replace(/<\/?p>/g, '');
  return (
    <>
      <div>
        <h3 className="text-info fw-bolder mb-3">Fun-Da-Mentals Kitchen Skills</h3>
        <ul role="list" className="w-list-unstyled">
          {kitchenSkills.map((skill, index) =>
            skill.description && (
              <li className="kitchen-skill-item" key={`skill-${skill.id}`}>
                <SafeHTMLDisplay htmlContent={`**${skill.name}**: ${cleanDescription(skill.description)}`} />
              </li>
            )
          )}
        </ul>
      </div>
      <div className="dots recipe"></div>
    </>
  );
};
export default RecipeSkills;
